import Button from '@mui/material/Button'
import * as css from './styles'
import { t } from '@lingui/core/macro'

interface ActionsProps {
  enableResyncAll: boolean
  isAllSyncsSuccessful: boolean
  totalSuccessful: number
  totalAssignments: number
  resyncButtonProps: {
    onClick: () => void
    disabled: boolean
  }
}

export const Actions = ({
  enableResyncAll,
  isAllSyncsSuccessful,
  totalSuccessful,
  totalAssignments,
  resyncButtonProps,
}: ActionsProps) => {
  return (
    <css.DestinationActions>
      <css.DestinationsCountTyphography>
        {isAllSyncsSuccessful
          ? t`All destinations successfully synced.`
          : t`${totalSuccessful} of ${totalAssignments} reporting destinations successfully synced.`}
      </css.DestinationsCountTyphography>
      {!isAllSyncsSuccessful && enableResyncAll ? (
        <Button
          variant="contained"
          onClick={resyncButtonProps.onClick}
          disabled={resyncButtonProps.disabled}
          disableElevation={true}
        >
          {t`Resync all failed`}
        </Button>
      ) : null}
    </css.DestinationActions>
  )
}
